import Vue from 'vue'
import App from './App'
import router from './router'

import BootstrapVue from 'bootstrap-vue'
import Cookies from 'js-cookie'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueGtag from 'vue-gtag'

import { store } from './store/store.js'

Vue.use(BootstrapVue)

Vue.config.productionTip = false

Vue.use(
  VueGtag,
  {config: {id: 'G-2FM2871ER0'}},
  router
)

//
// Language selection through URL
// Example:
//   https://www.wynelover.com/?lang=fr
//
const params = new URLSearchParams(window.location.search)

const supportedLanguages = [
  'en',
  'fr',
  'de',
  'es',
  'it',
  'nl',
  'pt'
]

const lang = params.get('lang')

if (lang && supportedLanguages.includes(lang.toLowerCase())) {
  const language = lang.toLowerCase()

  Cookies.set('wynelover.language', language, {
    expires: 365,
    path: '/'
  })

  store.commit('setLanguage', language)

  // Optional: remove ?lang=... from the address bar
  window.history.replaceState({}, '', window.location.pathname)
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
